<template>
	<section
		v-if="isReady"
		class="prebuild-features"
		:style="{ backgroundImage: `url(${backgroundImage})` }"
	>
		<div class="container">
			<div class="row">
				<div class="col-md-4">
					<div class="prebuild-features__list">
						<div
							v-for="feature in prebuildFeatures"
							class="prebuild-features__feature"
							:key="feature.id"
						>
							<div class="prebuild-features__feature__icon">
								<img
									:src="feature.mini_logo_url"
									:alt="feature.title + ' icon'"
								>
							</div>
							<div class="prebuild-features__feature__text">
								<h4 class="prebuild-features__feature__heading">
									{{ feature.title | stripTags }}
								</h4>
								<p class="prebuild-features__feature__description">
									{{ feature.body | stripTags }}
								</p>
							</div>
						</div>
					</div>
				</div>
				<div class="col-md-8">
					<div class="prebuild-features__main-image">
						<img
							class="prebuild-features__main-image__mobile"
							:src="desktopLogo"
							alt="BLD Prebuild PC"
						>
						<img
							class="prebuild-features__main-image__desktop"
							:src="mobileLogo"
							alt="BLD Prebuild PC"
						>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import isEmpty from "lodash/isEmpty";

export default {
	name: "PrebuildFeatures",
	props: {
		featuresData: {
			type: Array,
			default() {
				return [];
			}
		}
	},
	computed: {
		isReady() {
			return !isEmpty(this.featuresData);
		},
		prebuildFeatures() {
			const [, , ...rest] = this.featuresData;
			return rest;
		},
		desktopFeatureData() {
			const [, desktop = {}] = this.featuresData;
			return desktop;
		},
		mobileFeatureData() {
			const [mobile = {}] = this.featuresData;
			return mobile;
		},
		mobileLogo() {
			const { logo_url: logoURL = "" } = this.mobileFeatureData;
			return logoURL;
		},
		desktopLogo() {
			const { logo_url: logoURL = "" } = this.desktopFeatureData;
			return logoURL;
		},
		backgroundImage() {
			let { background_url: backgroundURL = "" } = this.mobileFeatureData;
			const SCREEN_RESOLUTION_BREAKPOINT = 580;

			if ($(window).width() <= SCREEN_RESOLUTION_BREAKPOINT) {
				const { background_url: desktopBgURL = "" } = this.desktopFeatureData;
				backgroundURL = desktopBgURL;
			}

			return backgroundURL;
		}
	}
};
</script>

<style lang="scss" scoped>
.prebuild-features {
	padding-top: 65px;
	background-size: 100%;
	background-repeat: no-repeat;
	overflow: hidden;

	@media (min-width: 991px) {
		padding-top: 105px;
	}

	@media (min-width: 580px) and (max-width: 991px) {
		background-repeat: no-repeat;
		background-position: 100% 0%;
		background-size: 160%;
	}

	.row {
		display: flex;
		flex-direction: column-reverse;

		@media (min-width: 991px) {
			display: block;
		}
	}

	&__list {
		@media (min-width: 580px) and (max-width: 991px) {
			display: flex;
			margin-top: 50px;
		}

		@media (min-width: 991px) {
			margin-top: 70px;
			margin-bottom: 100px;
		}
	}

	&__feature {
		margin-bottom: 50px;

		@media (min-width: 580px) and (max-width: 991px) {
			padding: 0px 12px;
		}

		@media (min-width: 991px) {
			display: flex;
			margin-bottom: 40px;
		}

		&__icon {
			width: 50px;
			flex-shrink: 0;
			margin: 0 auto 15px;

			@media (min-width: 991px) {
				margin-right: 15px;
				width: 32px;
			}

			img {
				width: 100%;
			}
		}

		&__text {
			text-align: center;
			max-width: 330px;
			margin: 0 auto;

			@media (min-width: 991px) {
				text-align: left;
			}
		}

		&__heading {
			color: #ffffff;
			font-size: 24px;
			font-weight: bold;
			letter-spacing: 0;
			margin: 0 0 10px;

			@media (min-width: 580px) and (max-width: 991px) {
				font-size: 23px;
			}
		}

		&__description {
			opacity: 0.7;
			color: #ffffff;
			font-size: 16px;
			letter-spacing: 0;
			line-height: 24px;
		}
	}

	&__main-image {
		max-width: 330px;
		margin: 0 auto 30px;

		@media (min-width: 580px) and (max-width: 991px) {
			max-width: 470px;
		}

		@media (min-width: 991px) {
			max-width: 100%;
			position: absolute;
			right: -25%;
			top: 0px;
		}

		@media (min-width: 1200px) {
			top: -50px;
			right: -30%;
		}

		&__mobile {
			@media (min-width: 580px) {
				display: none;
			}
		}

		&__desktop {
			display: none;

			@media (min-width: 580px) {
				display: block;
			}
		}

		img {
			width: 100%;
		}
	}
}
</style>
